import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyALJVldT170U72Utt43GOtl7U9ltyEC9XE",
  authDomain: "wedding-invitation-ce6c5.firebaseapp.com",
  databaseURL: "https://wedding-invitation-ce6c5-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "wedding-invitation-ce6c5",
  storageBucket: "wedding-invitation-ce6c5.firebasestorage.app",
  messagingSenderId: "290735149175",
  appId: "1:290735149175:web:e6add0a0a3d3a70c5b7672",
  measurementId: "G-65VKSH6CRR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database
export const database = getDatabase(app);

